import {
  BaSeBreakpointContext,
  BaSeCheckbox,
  BaSeDialogContext,
  BaSeHeading4,
  BaSeHeading5,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import ReactPlayer from 'react-player';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { mapTermsConditions } from '../../../../utils/texts/conditions-term';
import Button from '../button';
import {
  ButtonConfirmWrapper,
  CheckboxFooter,
  Content,
  ContentStepperOne,
  TermAndConditions,
  TermAndConditionsContent,
  TermAndConditionsFooter,
  TermAndConditionsHeader,
  TextHeader,
  TextWrapper,
} from './meet-empretec-styled';

const textMeetEmpretec = {
  1: 'Para começar, gostaríamos que você conhecesse um pouco mais sobre o Seminário para avaliar se esse é o melhor momento para você fazê-lo.',
  2: 'Esta etapa consiste em um questionário em que iremos conhecer um pouco mais sobre o perfil da sua startup para assim avaliar sua participação no seminário.',
  3: 'Para começar, gostaríamos que você conhecesse um pouco mais sobre o Seminário para avaliar se esse é o melhor momento para você fazê-lo.',
};

const textVideoEmpretec = {
  1: 'Assista ao vídeo e, caso esteja de acordo, dê o aceite para continuar o processo de inscrição para a entrevista de seleção.',
  2: 'Assista ao vídeo e, caso esteja de acordo, dê o aceite para continuar o processo de inscrição para o questionário de seleção.',
  3: 'Assista ao vídeo e, caso esteja de acordo, dê o aceite para continuar o processo de inscrição para a entrevista de seleção.',
};

export const MeetEmpretec = ({
  setCurrentStep,
  interview,
  pageSettings,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const { setConditionalUse } = useInterviewController();
  const breakpointController = React.useContext(BaSeBreakpointContext);
  const { showNotification } = React.useContext(BaSeDialogContext);
  const [term, setTerm] = React.useState(interview?.acceptedTerm ?? false);
  const [statusVideo, setStatusVideo] = React.useState(
    interview?.viewedVideo ?? false,
  );
  const [termsConditions, setTermsConditions] = React.useState({});
  const { handleError } = useMessage();

  React.useEffect(() => {
    const data = mapTermsConditions(interview.module.id);
    setTermsConditions(data);
  }, [interview]);

  const onVideoEnd = React.useCallback(() => {
    setStatusVideo(true);
  }, []);

  const handleMessage = React.useCallback(() => {
    showNotification({
      message: 'Você precisa ver o vídeo para avançar',
      supportMessage:
        'Além de aceitar os termos é necessário ver todo o vídeo acima para continuar a inscrição.',
      secondsToClose: 5,
      color: 'default',
    });
  }, [showNotification]);

  const confirm = React.useCallback(() => {
    if (!statusVideo) {
      return handleMessage();
    }
    if (!interview) {
      return handleError(
        'Não foi possível recuperar a entrevista. Favor acessar através do e-mail novamente.',
      );
    }

    if (interview?.acceptedTerm && interview?.viewedVideo) {
      setCurrentStep((currentStep) => currentStep + 1);
    } else {
      setConditionalUse(interview.id, {
        acceptedTerm: term,
        viewedVideo: statusVideo,
      }).then(() => {
        setCurrentStep((currentStep) => currentStep + 1);
      });
    }
  }, [
    handleError,
    handleMessage,
    interview,
    setConditionalUse,
    setCurrentStep,
    statusVideo,
    term,
  ]);

  return (
    <Content>
      <ContentStepperOne>
        <TextWrapper>
          <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
            {textMeetEmpretec[interview?.module?.id]}
          </BaSeHeading5>
          <BaSeHeading5
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae97}
          >
            {textVideoEmpretec[interview?.module?.id]}
          </BaSeHeading5>
        </TextWrapper>
        <ReactPlayer
          url="https://vimeo.com/577228295/c39f5229b7"
          width={
            breakpointController.inDesktop ||
            breakpointController.inDesktopLarge ||
            breakpointController.inTablet
              ? '100%'
              : '90%'
          }
          height="100%"
          controls={true}
          config={{
            vimeo: {
              playerOptions: {
                responsive: true,
                playsinline: true,
              },
            },
            file: {
              attributes: {
                poster:
                  'https://i.vimeocdn.com/video/1194054632?mw=1300&mh=731',
              },
            },
          }}
          onEnded={onVideoEnd}
        />
        <TextWrapper>
          <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
            Agora que você já conhece mais sobre o seminário e dedicação
            necessária para fazê-lo, por favor, leia o termo a seguir e, caso
            esteja de acordo, clique em confirmar.
          </BaSeHeading5>
        </TextWrapper>
        <TermAndConditions>
          <TermAndConditionsHeader>
            <BaSeHeading4>
              <TextHeader>Termos e condições</TextHeader>
            </BaSeHeading4>
          </TermAndConditionsHeader>
          <TermAndConditionsContent>
            <BaSeParagraph
              isBold
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              {termsConditions.titulo}
            </BaSeParagraph>

            {termsConditions.descricoes?.map((desc) => (
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
                key={desc.id}
              >
                <BaSeParagraph
                  isBold
                  color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                >
                  {desc.titulo}
                </BaSeParagraph>
                {desc?.descricao.map((infoDesc) => (
                  <div
                    key={infoDesc}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <BaSeSmall1
                      color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                    >
                      {infoDesc}
                    </BaSeSmall1>
                  </div>
                ))}
              </div>
            ))}
          </TermAndConditionsContent>
          <TermAndConditionsFooter>
            <CheckboxFooter>
              <BaSeCheckbox
                size="small"
                checked={term}
                value={term}
                color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                onChange={(value) => setTerm(value)}
                label="Estou ciente e de acordo com as informações apresentadas acerca dos termos para participação no Empretec."
              />
            </CheckboxFooter>
          </TermAndConditionsFooter>
        </TermAndConditions>
      </ContentStepperOne>
      <ButtonConfirmWrapper>
        <Button
          disabled={!term}
          calback={confirm}
          color={pageSettings?.buttonColor}
          withBorder={term}
          borderColor={pageSettings?.buttonBorderColor}
          value="CONFIRMAR E AVANÇAR"
          valueSmall="CONFIRMAR E AVANÇAR"
          textColor="#fff"
        />
      </ButtonConfirmWrapper>
    </Content>
  );
};
